import { service } from '../../../service';

const state = {
  loading: false,
  items: [],
  unallocatedInvoiceItems: [],
  unallocatedTimesheetItems: [],
  candidateItems: {
    booking: {
      docs: [],
      totalDocs: 0,
    },
  },
  chart_data: [],
  chart_data_booking_per_client: [],
  chart_processed_line: '',
  chart_processed_doughnut: '',
  timesheetBookings: null,
};

const actions = {
  async storeChartData({ commit, rootState }, dataObject) {
    commit('setProcessedChartData', dataObject);
  },
  async resetWindowHistoryDataState({ commit, rootState }, urlParams) {
    commit('setLoading', true);
    commit('setBookingChartData', {
      booking_total_hours_weekly: [],
      booking_total_hours_client: [],
    });
    commit('setCandidateItems', {
      booking: {
        docs: [],
        totalDocs: 0,
      },
    });

    commit('setProcessedChartData', '');
  },
  async fetchBookingChartData({ commit, rootState }, urlParams) {
    commit('setLoading', true);

    var url = `/bookings/chart/${urlParams.frequency}/candidate/${urlParams.candidate_id}?start_date=${urlParams.start_date}&end_date=${urlParams.end_date}`;
    return service.get(url).then((result) => {
      commit('setBookingChartData', result);
      return;
    });
  },

  async fetch({ commit, rootState }) {
    commit('setLoading', true);

    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}`
      )

      .then((result) => {
        console.log(result);
        commit('setItems', result);
      });
  },

  async fetchById({ commit, rootState }, id) {
    commit('setLoading', true);

    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}/${id}`
      )
      .then((result) => {
        commit('setLoading', false);
        return result;
      });
  },

  async fetchByInvoice({ commit, rootState }, id) {
    commit('setLoading', true);

    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}?invoice=${id}`
      )
      .then((result) => {
        commit('setLoading', false);
        return result;
      });
  },

  async fetchByTimesheet({ commit, rootState }, id) {
    commit('setLoading', true);

    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}?timesheet=${id}`
      )
      .then((result) => {
        commit('setLoading', false);
        commit('setTimesheetBookings', result);
        return result;
      });
  },

  async fetchByCandidate({ commit, rootState }, data) {
    commit('setLoading', true);

    var url = `/bookings/${data.candidate_id}`;
    url = url.params(data);
    return service.get(url).then((result) => {
      commit('setCandidateItems', result);
    });
  },

  async fetchUnallocatedTimesheetBookings({ commit, rootState }) {
    commit('setLoading', true);

    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}?timesheet=none`
      )
      .then((result) => {
        commit('setUnallocatedTimesheetItems', result);
      });
  },

  async fetchUnallocatedInvoiceBookings({ commit, rootState }) {
    commit('setLoading', true);
    return service
      .get(
        `/bookings/${rootState.account.company._id}/${rootState.account.location._id}?invoice=none`
      )
      .then((result) => {
        commit('setUnallocatedInvoiceItems', result);
      });
  },

  async create({ dispatch, commit, rootState }, payload) {
    return service
      .post(
        `/timesheets/${rootState.account.company._id}/${rootState.account.location._id}`,
        payload
      )
      .then((result) => {
        console.log(result);
        // commit('newItem', result.timsheet);
        dispatch('alert/success', result.message, { root: true });
        return result.client;
      });
  },

  async update({ dispatch, commit, rootState }, payload) {
    return service
      .patch(
        `/timesheets/${rootState.account.company._id}/${payload._id}`,
        payload
      )
      .then((result) => {
        commit('updateItem', result.timesheet);
        dispatch('alert/success', result.message, { root: true });
        return result.client;
      });
  },

  async delete({ dispatch, commit, rootState }, payload) {
    return service
      .delete(`/timesheets/${rootState.account.company._id}/${payload._id}`)
      .then((result) => {
        commit('deleteItem', result.id);
        dispatch('alert/success', result.message, { root: true });
        return;
      });
  },
};

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setBookingChartData(state, items) {
    state.chart_data = items.booking_total_hours_weekly;
    state.chart_data_booking_per_client = items.booking_total_hours_client;
    state.chart_processed_line = '';
    state.chart_processed_doughnut = '';
    state.loading = false;
  },
  setTimesheetBookings(state, items) {
    state.timesheetBookings = items;
    state.loading = false;
  },
  setProcessedChartData(state, items) {
    if (items.type == 'line') {
      delete items.type;
      state.chart_processed_line = items;
    } else if (items.type == 'doughnut') {
      delete items.type;
      state.chart_processed_doughnut = items;
    } else {
      state.chart_processed_line = '';
      state.chart_processed_doughnut = '';
    }
  },
  setItems(state, items) {
    state.items = items;
    state.loading = false;
  },
  setUnallocatedInvoiceItems(state, items) {
    state.unallocatedInvoiceItems = items;
    state.loading = false;
  },
  setUnallocatedTimesheetItems(state, items) {
    state.unallocatedTimesheetItems = items;
    state.loading = false;
  },
  setCandidateItems(state, items) {
    state.candidateItems = items;
    state.loading = false;
  },
  newItem(state, item) {
    state.items.push(item);
    state.loading = false;
  },
  updateItem(state, item) {
    var index = state.items.findIndex((i) => {
      return i._id === item._id;
    });
    if (index !== -1) {
      state.items.splice(index, 1, item);
    }
    state.loading = false;
  },
  deleteItem(state, id) {
    var index = state.items.findIndex((i) => {
      return i._id === id;
    });
    if (index !== -1) {
      state.items.splice(index, 1);
    }
    state.loading = false;
  },
};

export const bookings = {
  namespaced: true,
  state,
  actions,
  mutations,
};
